<template>
  <input-base
      ref="base"
      :read-only="readOnly"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :editor-mode="editorMode"
  >
    <template slot="editor">
      <FormattedInput
          :validated-field="validatedField"
          v-model="validatedField.value"
          :read-only="readOnly"
          class="w-100"
          @focusout="focusOut"
      >
      </FormattedInput>
    </template>
  </input-base>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import InputBase from "@/components/inputs/InputBase";
import FormattedInput from "@/components/inputs/controls/FormattedInput";
import {parseIconName} from "@/FontAwesomeSetup";

export default {
  name: "FormattedTextRenderer",
  components: {FormattedInput, InputBase, ReachInput},

  mounted() {
  },


  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },
    focusOut() {
      console.log('focout-out')
      this.validatedField?.validate();
    },
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: TextFormFieldConfig, required: true},
  },


  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>